<template>
	<div class="modal is-active">
		<div class="modal-background"></div>
		<div class="modal-card">
			<header class="modal-card-head">
				<p class="modal-card-title" >Compartilhamento de Layout - Atenção</p>
				<button class="delete" aria-label="close" @click="goBack"></button>
			</header>
			<section class="modal-card-body" v-show="isLoading">
				<Spinner size="30" />
			</section>
			<form @submit.prevent="onSubmit()" v-show="!isLoading">

				<section class="modal-card-body" >

					<p>Você acessou um link que corresponde a um Layout compartilhado por outro usuário. Se clicar em avançar, este novo layout, juntamente às Categorias e seus Links irão se sobrepor ao layout atual de sua página. Tem certeza que deseja continuar?</p>

				</section>

				<footer class="modal-card-foot">
					<button type="submit" class="button is-success">Aceitar</button>
					<button class="button" @click.prevent="goBack">Recusar</button>
				</footer>

			</form>
		</div>
	</div>
</template>

<style>

	.blue { color:#0057ff; }


fieldset + fieldset {
  margin-top: 15px;
}
fieldset legend{
  text-align: center;
  margin-bottom: 10px;
}


</style>

<script>

import firebase from '@/firebase'
import Spinner from '../components/Spinner'

export default {
	components:{
		Spinner
	},
	data() {
		return {
			sharedDashboardId: '',
			isLoading:false,
			profile:{},
		}
	},
	computed: {
		userId() {
			return this.$store.getters.userId;
		},
	},
	methods:{
		goBack(){
			this.$router.push({name:'home'});
		},
		onSubmit(){

			console.log('batch started');
			const db = firebase.firestore();
			this.$store.dispatch('startLoading');

			let userRef = db.collection('users').doc(this.userId);


			let profile = this.profile;

			let batch = db.batch();

			let userPreferences = {
				tema: profile.preferences.tema,
				iconSize: profile.preferences.iconSize,
				iconCorners: profile.preferences.iconCorners,
				columnCount: profile.preferences.columnCount,
				hasOpacity: profile.preferences.hasOpacity,
				transparency: profile.preferences.transparency,
				textColor: profile.preferences.textColor,
				bg: profile.preferences.bg,
			};

			batch.update(userRef,userPreferences);

			let i;
			console.log('delete old categories');
			let categories = this.$store.state.categories.categories;
			for(i in categories){
				let catDocRef = userRef.collection('categories').doc(categories[i].id);
				batch.delete(catDocRef);
			}

			console.log('delete old links');
			let links = this.$store.state.categories.links;
			for(i in links){
				let linkDocRef = userRef.collection('links').doc(links[i].id);
				batch.delete(linkDocRef);
			}

			console.log('create new categories');
			categories = profile.categories;
			for(i in categories){
				let catDocRef = userRef.collection('categories').doc(categories[i].id);
				batch.set(catDocRef,categories[i]);
			}

			console.log('create new links');
			links = profile.links;
			for(i in links){
				let linkDocRef = userRef.collection('links').doc(links[i].id);
				batch.set(linkDocRef,links[i]);
			}


			batch.commit().then(() => {

				let user = this.$store.state.user;
				for (i in userPreferences){
					user[i] = userPreferences[i];
				}
				this.$store.dispatch('reloadUser',{user:user})

				console.log('batch finished');
				console.log('query started');
				var q1 = this.$store.dispatch('queryCategories');
				var q2 = this.$store.dispatch('queryLinks');
				Promise.all([q1, q2]).then(()=>{
					console.log('query finished');
					this.$store.dispatch('stopLoading');
					this.$router.push({name:'home'});
				})
			}).catch((error)=>{
				console.log('batch error');
				console.log(error);
				this.$store.dispatch('stopLoading');
			});

		},
	},
	mounted() {
		this.isLoading = true;
		let uid = this.$store.state.sharedDashboardId;
		this.$store.dispatch('setSharedDashboardId',{id:''});
		this.sharedDashboardId = uid;

		const db = firebase.firestore();
		db.collection('shared_dashboards').doc(uid).get().then(doc=>{
			this.profile = doc.data();
			this.isLoading = false;
		}).catch(()=>{
			this.isLoading = false;
		})

	},
};
</script>

